/**
 * Glass Specification options for Visual Designer items. Supplier outputs only.
 * Pure module: scripts/sync-edge-shared.js copies it into supabase/functions/_shared.
 */
export type GlassSpecificationCode = 'annealed' | 'toughened' | 'laminated' | 'toughened-laminated' | 'heat-soak';

export const GLASS_SPECIFICATION_OPTIONS: Array<{ code: GlassSpecificationCode; label: string }> = [
  { code: 'annealed', label: 'Annealed' },
  { code: 'toughened', label: 'Toughened' },
  { code: 'laminated', label: 'Laminated' },
  { code: 'toughened-laminated', label: 'Toughened & Laminated' },
  { code: 'heat-soak', label: 'Heat Soak' },
];

export const DEFAULT_GLASS_SPECIFICATION: GlassSpecificationCode = 'annealed';

export const formatGlassSpecification = (raw: unknown): string => {
  const code = String(raw || '').trim().toLowerCase();
  return GLASS_SPECIFICATION_OPTIONS.find((o) => o.code === code)?.label || '';
};

export const parseGlassSpecificationCode = (raw: unknown): GlassSpecificationCode => {
  const code = String(raw || '').trim().toLowerCase();
  return GLASS_SPECIFICATION_OPTIONS.find((o) => o.code === code)?.code || DEFAULT_GLASS_SPECIFICATION;
};
